// View mode constants for StocksList component
export const VIEW_MODES = {
  STOCKS: 'stocks',
  SECTORS: 'sectors',
};